import React, { useCallback, useEffect, useState } from 'react'
import styles from './styles.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { getEducDirections, deleteEducDirection, createEducDirection, updateEducDirection } from '../../actions/educDirections'
import Li from '../../components/Li'
import Button from '../../components/Button'
import Modal from 'react-responsive-modal'
import { useFormik } from 'formik'
import { Checkbox, Input } from '../../components/ModalInputs'
import Confirmation from '../../components/Confirmation/Confirmation'
import { BiTrash } from 'react-icons/bi'
import * as Yup from 'yup'


const validationSchema = Yup.object().shape({
  name: Yup.string()
    .min(1, 'Пожалуйста, введите имя')
    .max(50, 'Имя не может превышать 50 символов')
    .required('Это поле обязательно для заполнения'),
});

const INITIAL_VALUES = {
  name: '',
  reporthse: 0,
  sporting: 0
}

const EducDirections = ({ data, setModalValue, closeSubModal }) => {

  const dispatch = useDispatch()
  const { list, loading } = useSelector(state => state.educ_directions)

  const [selectedItem, setSelectedItem] = useState(null)
  const [confirmation, setConfirmation] = useState(null)
  const [select, setSelect] = useState(null)

  useEffect(() => {
    dispatch(getEducDirections())
  }, [])

  const deleteItem = (id) => (e) => {
    e.stopPropagation()
    setConfirmation(id)
  }

  const openModal = (data) => () => setSelectedItem(data || {})

  const closeModal = () => setSelectedItem(null)

  const renderLi = (item) => (
    <Li
      onClick={() => handleSelect(item)}
      onDoubleClick={openModal(item)}
      style={{ backgroundColor: select?.edid === item.edid ? '#3689FF' : '' }}
    >
      <span>{item.name}</span>
      <BiTrash size={24} color='red' title='Удалить' onClick={deleteItem(item.edid)} />
    </Li>
  )

  const acceptConfirmation = () => {
    dispatch(deleteEducDirection(confirmation))
    setConfirmation(null)
  }

  const rejectConfirmation = () => {
    setConfirmation(null)
  }

  const handleSelect = (item) => {
    if (data === 'eventList') {
      const isSelected = select?.edid === item.edid;
      setSelect(isSelected ? null : item);
      if (!isSelected) setModalValue({ edid: item.edid });
    }
  };

  return (
    <div className={styles.wrapper}>
      <h1>Направления воспитательной работы</h1>
      <ul>{list?.map(renderLi)}</ul>
      <div className={styles.bottonsRow}>
        <Button onClick={openModal()}>Добавить</Button>
        {
          !!select?.edid && <Button onClick={() => closeSubModal()}>Выбрать</Button>
        }
      </div>
      <ModalComponent
        open={!!selectedItem}
        closeModal={closeModal}
        data={selectedItem}
        addMode={!selectedItem?.edid}
      />
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title="Уверены что хотите удалить запись?"
          acceptConfirmation={acceptConfirmation}
          rejectConfirmation={rejectConfirmation}
        />
      )}
    </div>
  )
}


const ModalComponent = ({ open, closeModal, data, addMode }) => {

  const dispatch = useDispatch()

  const [confirmClose, setConfirmClose] = useState(false)

  useEffect(() => {
    if (!open) return;
    setValues(addMode ? INITIAL_VALUES : data)
  }, [open])


  const createItem = async (values) => {
    const success = await dispatch(createEducDirection(values))
    success && closeModal()
  }

  const updateItem = async ({ edid, ...values }) => {
    const success = await dispatch(updateEducDirection(edid, values))
    success && closeModal()
  }

  const {
    values,
    errors,
    touched,
    dirty,
    submitCount,
    handleBlur,
    handleSubmit,
    handleChange,
    setValues,
    setFieldValue
  } = useFormik({
    initialValues: addMode ? INITIAL_VALUES : data,
    enableReinitialize: true,
    validationSchema,
    onSubmit: addMode ? createItem : updateItem
  })

  const error = (fieldName) => (touched[fieldName] || submitCount) && errors[fieldName]

  const handleClose = useCallback(() => {
    if (dirty) setConfirmClose(true); else closeModal()
  }, [dirty, closeModal])

  const acceptConfirmation = useCallback(() => { closeModal(); setConfirmClose(false) }, [closeModal])

  const rejectConfirmation = useCallback(() => setConfirmClose(false), [])

  return (
    <Modal
      open={open}
      onClose={handleClose}
      classNames={{ modal: styles.modal }}
      closeOnEsc={true}
      closeOnOverlayClick={true}
      showCloseIcon={false}
      animationDuration={2}
      center
    >
      <div className={styles.modalMain}>
        <h2>{addMode ? 'Добавление записи' : 'Редактирование записи'}</h2>
        <Input
          name='name'
          label='Название'
          value={values.name}
          error={error('name')}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        <Checkbox
          name='reporthse'
          label='отчет ВШЭ'
          checked={values.reporthse}
          onChange={() => setFieldValue('reporthse', Number(!values.reporthse))}
        />
        <Checkbox
          name='sporting'
          label='спортивное'
          checked={values.sporting}
          onChange={() => setFieldValue('sporting', Number(!values.sporting))}
        />
      </div>
      <div className={styles.modalFooter}>
        <div>
          <div></div>
          <div></div>
        </div>
        <Button mode='white' type="submit" onClick={handleSubmit}>Сохранить</Button>
        <Button mode='white' onClick={handleClose}>Закрыть</Button>
      </div>
      {confirmClose && (
        <Confirmation
          title="Закрыть без сохранения изменений?"
          acceptConfirmation={acceptConfirmation}
          rejectConfirmation={rejectConfirmation}
        />
      )}
    </Modal>
  )
}


export default EducDirections